const withdrawal = {
    getlist: 'withdrawal/getlist-by-admin',
    pay: 'withdrawal/pay',
    reject: 'withdrawal/reject',
}
export default withdrawal
